import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environments/environment';

export const SERVER_API_URL = environment.serverUrl;
const routes = {
  signIn: {
    login: () => `${SERVER_API_URL}/api/v1/EmployeeLogin`,
    getguestuserEmpLoginDetails: (emp_id: any) => `${SERVER_API_URL}/api/v1/getEmpLoginDetails/${emp_id}`
  },
  forgot: {
    forgetPasswordForAdmin: () => `${SERVER_API_URL}/api/v1/forgetPasswordForAdmin`,
  },
  reset: {
    resetEmpPassword: () => `${SERVER_API_URL}/api/v1/resetEmpPassword`,
  },
  chat: {
    markAllAsRead: (userId: number | string) => `${SERVER_API_URL}/api/v1/markAsAllRead/${userId}`,
  }


};
@Injectable({ providedIn: 'root', })
export class LoginService {

  constructor(private http: HttpClient) { }

  userLogin(data: any): Observable<any> {
    return this.http.post<any>(routes.signIn.login(), data, { observe: 'response' });
  }
  guestusergetEmpLoginDetails(emp_id: any): Observable<any> {
    return this.http.get<any>(routes.signIn.getguestuserEmpLoginDetails(emp_id), { observe: 'response' });
  }
  forgetPasswordForAdmin(data: any): Observable<any> {
    return this.http.post<any>(routes.forgot.forgetPasswordForAdmin(), data, { observe: 'response' });
  }
  resetEmpPassword(data: any): Observable<any> {
    return this.http.patch<any>(routes.reset.resetEmpPassword(), data, { observe: 'response' });
  }
  markAllMessagesAsRead(userId: number | string): Observable<any> {
    return this.http.put<any>(routes.chat.markAllAsRead(userId), {});
  }
}